export function getDeviceId() {
  return new Promise(resolve => {
    try {
      const { android, webkit } = window;

      if (android && android.close && typeof android.getDeviceId === 'function') {
        resolve(android.getDeviceId());
      }

      if (
        webkit &&
        webkit.messageHandlers &&
        webkit.messageHandlers.getDeviceId &&
        typeof webkit.messageHandlers.getDeviceId.postMessage === 'function'
      ) {
        webkit.messageHandlers.getDeviceId.postMessage('');
        window.onReceiveDeviceId = deviceId => resolve(deviceId);
      } else {
        resolve('');
      }
    } catch (e) {
      resolve('');
    }
  });
}

export default {
  getDeviceId,
};
